import { isMobile } from "react-device-detect";
import { useGenerateCertificate } from "../hooks/useGenerateCertificate";
import { useState } from "react";
import ProtectedResumeWrapper from "./wrapper/ProtectedResumeWrapper";
import { capitalizeName } from "../utils/utils";

const RenerateStudentResume = () => {
  const firstname = capitalizeName(sessionStorage.getItem("first_name"));
  const lastname = capitalizeName(sessionStorage.getItem("last_name"));
  const categoryId = sessionStorage.getItem("program_category_id");

  const [generateTrigger, setGenerateTrigger] = useState(false);
  const [programName, setProgramName] = useState(
    "Natural Language Processing & Its Applications"
  );

  const { certificatePdfUrl, generating, certificateImageUrl } =
    useGenerateCertificate({
      userName: firstname +" "+ lastname,
      courseName: programName,
    //   isMumbai: categoryId == 10 ? true : false,
      isMumbai:true,
      trigger: generateTrigger,
    });

  const handleDownloadPDF = () => {
    if (!certificatePdfUrl) return;

    const a = document.createElement("a");
    a.href = certificatePdfUrl;
    a.download = "certificate.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleChange = (event) => {
    setProgramName(event.target.value);
  };

  return (
    <ProtectedResumeWrapper>
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                <div className="card shadow-lg border-0 rounded-4">
                    <div className="card-body p-4">
                    <h3 className="card-title text-center mb-4 fw-bold text-primary">
                        🎓 Generate Student Certificate
                    </h3>

                    <div className="mb-3">
                        <label htmlFor="programName" className="form-label fw-semibold">
                        Program Name
                        </label>
                        <input
                        id="programName"
                        type="text"
                        value={programName}
                        onChange={handleChange}
                        className="form-control"
                        />
                    </div>
                    {/* Generate Button */}
                    <div className="d-grid gap-2 mb-4">
                        <button
                        className="btn btn-success"
                        onClick={() => setGenerateTrigger(Date.now())}
                        disabled={generating}
                        >
                        {generating ? (
                            <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Generating...
                            </>
                        ) : (
                            "Generate Certificate"
                        )}
                        </button>
                    </div>

                    {/* Display Certificate */}
                    {!isMobile ? (
                        <>
                        {certificateImageUrl && (
                            <div className="text-center mb-3">
                            <img
                                src={certificateImageUrl}
                                alt="Certificate Preview"
                                className="img-fluid rounded shadow-sm border"
                            />
                            </div>
                        )}

                        <div className="text-center">
                            <button
                            className="btn btn-primary"
                            onClick={handleDownloadPDF}
                            disabled={!certificatePdfUrl}
                            >
                            ⬇️ Download Certificate (PDF)
                            </button>
                        </div>
                        </>
                    ) : (
                        <div className="text-center">
                        <div
                            style={{
                            fontSize: "48px",
                            color: "#28a745",
                            marginBottom: "12px",
                            }}
                        >
                            ✅
                        </div>
                        <h5 className="mb-2">Certificate Generated</h5>
                        <p className="text-muted mb-3">
                            Your download should start automatically. <br />
                            If not, tap the button below.
                        </p>
                        <button
                            className="btn btn-success"
                            onClick={handleDownloadPDF}
                        >
                            Download Again
                        </button>
                        </div>
                    )}
                    </div>
                </div>
                </div>
            </div>
        </div>
    </ProtectedResumeWrapper>
  );
};

export default RenerateStudentResume;
